<template>
    <el-dialog title="表单模版库" :visible.sync="formTemplateLibraryDialog" width="998px" :before-close="handleDialogClose" :close-on-click-modal="false" class="custom-form-dialog">
        <div class="formTemplateLibrary_wrap">
            <div class="formTemplateLibrary_left_wrap">
                <ul>
                    <li class="ellipsis custom_hover_active_class font_bold active"><span>全部</span></li>
                    <li class="ellipsis custom_hover_active_class font_bold" v-for="item in classificationList"><span v-text="item.name"></span></li>
                </ul>
            </div>
            <div class="formTemplateLibrary_right_wrap">
                <div class="formTemplateLibrary_right_top">
                    <span class="title">全部</span>
                    <el-input size="small" v-model="keywords" placeholder="搜索模版"></el-input>
                </div>
                <div class="formTemplateLibrary_right_bottom">
                    <ul>
                        <li @click="handleClickAddApprovel">
                            <div class="title ellipsis"><img src="https://download.hecoos.com/enlightv/2024-46/4c539449c8a0da77f2cd2d3a8a9ed204.png" alt="">新建空白表单</div>
                            <div class="text ellipsis">自定义选择字段创建审批</div>
                            <div class="content_wrap">
                               <div class="content">
                                   <div class="subtitle ellipsis">自定义</div>
                                   <div class="cover">
                                       <img src="https://download.hecoos.com/enlightv/2024-46/e897360bf5ee5496f314d5c21e87daa8.png" alt="">
                                   </div>
                               </div>
                            </div>
                        </li>
                        <li v-for="item in templateList">
                            <div class="title ellipsis"><img :src="item.icon" alt="">{{item.title}}</div>
                            <div class="text ellipsis" v-text="item.text"></div>
                            <div class="content_wrap">
                                <div class="content">
                                    <div class="subtitle ellipsis" v-text="item.title"></div>
                                    <div class="cover">
                                        <img :src="coverList[item.cover]" alt="">
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </el-dialog>
</template>
<script>
export default {
    props: {
        formTemplateLibraryDialog: {
            type: Boolean,
            default: false
        },

    },
    data() {
        return {
            keywords:'',
            classificationList:[
                {name:'假勤管理'},
                {name:'人事行政'},
            ],
            templateList:[
                {title:'请假申请',text:'用于提交每天请假申请',cover:'',icon:'https://download.hecoos.com/enlightv/2024-15/tfGhzaDyn5WRm7fjHif8.png'},
                {title:'请假申请',text:'用于提交每天请假申请',cover:'',icon:'https://download.hecoos.com/enlightv/2024-15/tfGhzaDyn5WRm7fjHif8.png'},
                {title:'请假申请',text:'用于提交每天请假申请',cover:'',icon:'https://download.hecoos.com/enlightv/2024-15/tfGhzaDyn5WRm7fjHif8.png'},
                {title:'请假申请',text:'用于提交每天请假申请',cover:'',icon:'https://download.hecoos.com/enlightv/2024-15/tfGhzaDyn5WRm7fjHif8.png'},
                {title:'请假申请',text:'用于提交每天请假申请',cover:'',icon:'https://download.hecoos.com/enlightv/2024-15/tfGhzaDyn5WRm7fjHif8.png'},
                {title:'请假申请',text:'用于提交每天请假申请',cover:'',icon:'https://download.hecoos.com/enlightv/2024-15/tfGhzaDyn5WRm7fjHif8.png'},
                {title:'请假申请',text:'用于提交每天请假申请',cover:'',icon:'https://download.hecoos.com/enlightv/2024-15/tfGhzaDyn5WRm7fjHif8.png'},
                {title:'请假申请',text:'用于提交每天请假申请',cover:'',icon:'https://download.hecoos.com/enlightv/2024-15/tfGhzaDyn5WRm7fjHif8.png'},
            ],
            coverList:[
                'https://download.hecoos.com/enlightv/2024-46/eaccf1e83e6909753598207bbae0be2e.png',
                'https://download.hecoos.com/enlightv/2024-46/47e7c294e18eb6819ad8a9add0e73fa4.png',
                'https://download.hecoos.com/enlightv/2024-46/425fcd9e9c0251fe38fba76fbf8e7bf6.png',
                'https://download.hecoos.com/enlightv/2024-46/2acb4705c1b3d9945409be4bd7e30bd3.png',
                'https://download.hecoos.com/enlightv/2024-46/3152935e3e618b83db5c7084fe639db5.png',
                'https://download.hecoos.com/enlightv/2024-46/00d938df066737fd22f9ed2ae8ccd98e.png',
                'https://download.hecoos.com/enlightv/2024-46/bbba8cce20d7a3730699086fabf064ce.png',
                'https://download.hecoos.com/enlightv/2024-46/63346b51517f9c946b4b2c50d696c189.png',
                'https://download.hecoos.com/enlightv/2024-46/720898b0a2a4e01f33c773890751c66a.png'
            ]
        }
    },
    created() {
        this.templateList.forEach((item)=>{
            this.$set(item,'cover',Math.floor(Math.random() * 9) + 1)
        })
        console.log(this.templateList);
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:formTemplateLibraryDialog", false)
        },
        // 新增审批
        handleClickAddApprovel(){
            this.$emit("update:formTemplateLibraryDialog", false)
            this.$router.push({
                name: 'approveAdminSettings',
            })
        },
        handleDialogConfirm() {

        },

    }
}
</script>
<style lang="scss" scoped >
::v-deep .el-dialog .el-dialog__header{
    border-bottom: none;
}
::v-deep .el-dialog .el-dialog__body{
    padding: 0 0 16px 0;
}
.formTemplateLibrary_wrap{
    width: 100%;
    display: flex;
    height: 70vh;
    .formTemplateLibrary_left_wrap{
        width: 230px;
        padding: 0 8px;
        box-sizing: border-box;
        overflow: auto;
        ul{
            width: 100%;
            li{
                padding: 0 16px;
                width: 100%;
                height: 38px;
                line-height: 38px;
                border-radius: 6px;
                cursor: pointer;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                color: rgba(102, 102, 102, 1);
                font-size: 14px;
            }
        }
    }
    .formTemplateLibrary_right_wrap{
        width: calc(100% - 230px);
        display: flex;
        flex-direction: column;
        .formTemplateLibrary_right_top{
            padding: 8px 24px 16px;
            box-sizing: border-box;
            background: #fff;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .title{
                color: rgba(51, 51, 51, 1);
                font-size: 14px;
                font-weight: bold;
            }
            .el-input{
                width: 262px;
            }
        }
        .formTemplateLibrary_right_bottom{
            width: 100%;
            height: calc(100% - 56px);
            background: rgba(247, 248, 250, 1);
            padding: 1px 18px 16px 16px;
            overflow-y: auto;
            ul{
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                li{
                    width: 232px;
                    height: 322px;
                    margin-right: 16px;
                    border-radius: 6px;
                    background: rgba(255, 255, 255, 1);
                    padding: 16px;
                    box-sizing: border-box;
                    cursor: pointer;
                    margin-top: 16px;
                    &:nth-of-type(3n){
                        margin-right: 0;
                    }
                    .title{
                        line-height: 22px;
                        font-size: 14px;
                        font-weight: bold;
                        color: rgba(51, 51, 51, 1);
                        display: flex;
                        align-items: center;
                        img{
                            width: 16px;
                            height: 16px;
                            margin-right: 8px;
                        }
                    }
                    .text{
                        margin-top: 4px;
                        line-height: 22px;
                        font-size: 14px;
                        color: rgba(102, 102, 102, 1);
                    }
                    .content_wrap{
                        margin-top: 12px;
                        border-radius: 4px;
                        background: rgba(237, 240, 244, 1);
                        padding: 4px;
                        box-sizing: border-box;
                        .content{
                            border-radius: 4px;
                            background: rgba(255, 255, 255, 1);
                            .subtitle{
                                padding:0 12px ;
                                line-height: 34px;
                                border-bottom: 1px solid rgba(232, 232, 232, 1);
                                box-sizing: border-box;
                            }
                            .cover{
                                width: 192px;
                                height: 187px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                img{
                                    max-width: 192px;
                                    max-height: 187px;
                                    display: block;
                                }
                            }
                        }
                    }

                }

            }
        }
    }
}
</style>